import { useEffect } from 'react'

import { Locale } from '@global/locale/Locale'

import { TickmillCompaniesEnum } from './companyName.utils'

export const useOnOpenLiveChat = (onOpenLiveChat: () => void): void => {
  useEffect(() => {
    document.addEventListener('open-live-chat', onOpenLiveChat)

    return () => {
      document.removeEventListener('open-live-chat', onOpenLiveChat)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export const useOnCloseLiveChat = (onCloseLiveChat: () => void): void => {
  useEffect(() => {
    document.addEventListener('close-live-chat', onCloseLiveChat)

    return () => {
      document.removeEventListener('close-live-chat', onCloseLiveChat)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export const dispatchEntitySelected = (
  entity: TickmillCompaniesEnum,
  locale: Locale,
  email?: string,
  firstName?: string
): void => {
  const event = new CustomEvent('entity-selected', {
    detail: { entity, email, firstName, locale },
    bubbles: true,
    cancelable: true,
  })
  document.dispatchEvent(event)
}

export const useOnEntitySelected = (
  callback: (
    entity: TickmillCompaniesEnum,
    language: Locale,
    email?: string,
    firstName?: string
  ) => void
): void => {
  useEffect(() => {
    const handleEntitySelected: EventListener = (event) => {
      const customEvent = event as CustomEvent
      callback(
        customEvent.detail.entity,
        customEvent.detail.locale,
        customEvent.detail.email,
        customEvent.detail.firstName
      )
    }
    document.addEventListener('entity-selected', handleEntitySelected)

    return () => {
      document.removeEventListener('entity-selected', handleEntitySelected)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export function getDomainName(noDot?: boolean) {
  const hostName = window.location.hostname
  const localhostDomainName = 'localhost'
  const hostNameLength = hostName.split('.').length
  const domainName = hostName.substring(
    hostName.lastIndexOf('.', hostName.lastIndexOf('.') - hostNameLength) + 1
  )
  if (domainName === localhostDomainName) {
    return domainName
  }
  if (noDot) {
    return hostName
  }
  return '.' + domainName
}

export function getLeadReferrer(referrer: string) {
  const hostName = window.location.hostname

  if (referrer.includes(hostName)) {
    return ''
  }

  return referrer
}
